import custom_axios from "../axios";
export const get_store_sync_status = async (id, formData) => {
  try {
    const response = await custom_axios.get(`/shopify/store`);
    return response.data;
  } catch (error) {
    console.error("Failed to find store sync info:", error);
    return true;
  }
};

export const logo_presigned_url = async (formData) => {
  try {
    const data = {
      name: formData.name,
      type: formData.type,
    };
    const response = await custom_axios.post(
      `/shopify/generate-store-logo-presigned-url`,
      data
    );
    return response;
  } catch (error) {
    console.error("Failed to generate  upload url:", error);
    throw error;
  }
};

export const delete_tags_category = async (categoryId) => {
  try {
    const response = await custom_axios.delete(`/store-settings/tags_category/${categoryId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const FETCH_SYNC_HISTORY = async (queryParams, payload) => {
  try {
    const queryString = queryParams
      .map((param) =>
        param.value ? `${param.key}=${encodeURIComponent(param.value)}` : ""
      )
      .filter(Boolean)
      .join("&");

    const response = await custom_axios.get(
      `/shopify/sync-history?${queryString}`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching orders:", error);
    throw error;
  }
};
export const POST_PICKLIST_BATCH = async (payload) => {
  try {
    const response = await custom_axios.post('/order/picklist-batch', payload);
    return response.data;
  } catch (error) {
    console.error("Failed to update picklist batch:", error);
    throw error;
  }
};

export const syncOrdersByDateRange = async (fromDate, toDate) => {
  try {
    const response = await custom_axios.get(
      `/shopify/manual-sync?fromDate=${fromDate}&toDate=${toDate}`
    );
    return response.data;
  } catch (error) {
    console.error("Failed to start manual sync:", error);
    throw error; 
  }
};